import { TransferNotesModal } from "../modals/TransferNotesModal";

export function SimpleNoteTransferModal({
  note,
  shouldShowTransferModal,
  setShouldShowTransferModal,
}) {
  return (
    <TransferNotesModal
      notes={[note]}
      shouldShowTransferModal={shouldShowTransferModal}
      setShouldShowTransferModal={setShouldShowTransferModal}
      wasAutoPrompted={true}
      bypassContext={true}
    />
  );
}
